export function padZero(num: number, width: number) {
    return pad(num + "", width, "0")
}

export function pad(n: string, width: number, padChar: string) {
    padChar = padChar || "0"
    n = n + ""
    return n.length >= width ? n : new Array(width - n.length + 1).join(padChar) + n
}
